import { createFileRoute, Link } from "@tanstack/react-router";
import { INDUSTRIES, BUSINESS } from "@/lib/site-data";

const TITLE = `Trades SEO by Industry | ${BUSINESS.shortName}`;
const DESC =
  "SEO and Google Ads built for plumbers, HVAC companies, electricians, and roofers across Utah County and the Wasatch Front.";

export const Route = createFileRoute("/industries")({
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESC },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESC },
      { property: "og:url", content: "/industries" },
    ],
    links: [{ rel: "canonical", href: "https://lehitradessaeo.com/industries" }],
  }),
  component: IndustriesIndex,
});

function IndustriesIndex() {
  return (
    <main className="mx-auto max-w-6xl px-6 py-20">
      <p className="text-xs font-medium uppercase tracking-[0.2em] text-muted-foreground">
        Industries
      </p>
      <h1 className="mt-3 font-display text-5xl tracking-tight md:text-6xl">
        Built for the trades we know
      </h1>
      <p className="mt-5 max-w-2xl text-lg text-muted-foreground">
        We don't do SEO for everyone. We do it for the four contractor verticals
        with the math that actually works on paid search and the Map Pack.
      </p>
      <div className="mt-12 grid gap-6 md:grid-cols-2">
        {INDUSTRIES.map((i) => (
          <Link
            key={i.slug}
            to="/industries/$industry"
            params={{ industry: i.slug }}
            className="group rounded-2xl border border-border bg-card p-6 transition hover:border-primary"
          >
            <p className="text-xs font-medium uppercase tracking-[0.2em] text-muted-foreground">
              {i.trade}
            </p>
            <h2 className="mt-3 font-display text-2xl tracking-tight">{i.name}</h2>
            <p className="mt-2 text-sm text-muted-foreground">{i.tagline}</p>
            <span className="mt-4 inline-block text-sm font-medium text-primary group-hover:underline">
              Read more →
            </span>
          </Link>
        ))}
      </div>
    </main>
  );
}